import { c as _c } from "react/compiler-runtime";
import { HStack, Text } from '@chakra-ui/react';
export const RecapRow = t0 => {
  const $ = _c(7);
  const {
    k,
    v
  } = t0;
  let t1;
  if ($[0] !== k) {
    t1 = <Text color="colorPalette.fg/50" fontSize="xs" fontWeight="semibold">{k}</Text>;
    $[0] = k;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== v) {
    t2 = <Text fontSize="xs">{v}</Text>;
    $[2] = v;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1 || $[5] !== t2) {
    t3 = <HStack justify="space-between">{t1}{t2}</HStack>;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
};